export default __webpack_public_path__ + "static/media/Shot_11.0000.29aa5c58.png";